import { getAuth } from '@beeline/lk-utils';

export const getAccessToken = async (): Promise<string> => {
  let accessToken: string | null = null;

  const auth = getAuth();
  if (auth) {
    accessToken = await auth.getAccessTokenAsync();
  }

  if (!accessToken) {
    const defaultToken =
      process.env.REACT_APP_DEFAULT_ADFS_TOKEN ??
      localStorage.getItem('E2E_TOKEN');
    if (defaultToken) accessToken = defaultToken;
  }

  if (!accessToken) {
    throw new Error(
      'Run application integrated with LKE -or- Set default token in the REACT_APP_DEFAULT_ADFS_TOKEN environment variable.',
    );
  }

  return accessToken;
};
